<!-- <ng-template #spinnerDiv let-modal>
    <div class="modal-body" align="center">
        <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <p #spinnerBody>{{text | translate}}&hellip;</p>
    </div>
</ng-template> -->

<div class="modal-body" align="center">
    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    <p #spinnerBody>{{spinner.text | translate}}&hellip;</p>
</div>
